<template>
  <div>
    <template v-if="!isEdit">
      <slot></slot>
      <a
        href="javascript:void(0);"
        @click="isEdit = true"
        v-if="$store.getters.getPackage == 'premium' && !isCoachlab"
      >
        <span class="fas fa-pencil-alt"></span>
      </a>
    </template>
    <template v-else>
      <template v-if="!combobox && !comboboxCustom">
        <div class="form-control">
          <input
            v-if="!textarea"
            type="text"
            class="form-control"
            :placeholder="placeholder"
            v-model="customer_value"
            maxlength="600"
          />
          <template v-else>
            <textarea
              rows="3"
              v-model="customer_value"
              style="resize: vertical; width: 90%;"
              maxlength="1000"
            ></textarea>
            <p>
              <small v-if="customer_value"> {{ customer_value.length }}/1000</small>
            </p>
          </template>
        </div>
      </template>
      <multiselect
        v-else-if="combobox"
        :options="itemOption"
        v-model="customer_value"
        :multiple="multiple"
        :taggable="true"
        @tag="addTag"
      >
      </multiselect>
      <multi-select-custom
        v-else-if="comboboxCustom"
        v-model="customer_value"
        :options="itemOption"
        :label="label"
        :trackBy="trackBy"
        :taggable="taggable"
        :multiple="multiple"
        @tag="customer_value = $event"
      >
      </multi-select-custom>
      <small style="color:red" v-if="errorMaxlength">
        {{ $t('message_cannot_be_longer_than_25_alphabets') }}</small
      >
      <div class="text-xs-center">
        <v-btn outline color="grey" small @click="cancelEdit">{{ $t('cancel') }}</v-btn>
        <v-btn depressed color="primary" small @click="saveEdit">{{ $t('Save') }}</v-btn>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import MultiSelectCustom from '../../elements/MultiSelectCustom.vue'
export default {
  props: {
    value: {
      default: undefined
    },
    userid: {
      default: undefined
    },
    placeholder: {
      default: ''
    },
    itemOption: {
      default: undefined
    },
    label: {
      type: String
    },
    trackBy: {
      type: String
    },
    taggable: {
      type: Boolean,
      default: false
    },
    multiple: {
      default: false
    },
    combobox: {
      default: false
    },
    comboboxCustom: {
      default: false
    },
    textarea: {
      default: false
    }
  },
  data: function() {
    return {
      errorMaxlength: false,
      isEdit: false,
      customer_value: ''
    }
  },
  mounted: function() {
    this.customer_value = this.value
    this.cached_customer_value = this.value
  },
  components: {
    Multiselect,
    MultiSelectCustom
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      isCoachlab: 'isCoachlab'
    })
  },
  methods: {
    addTag(newTag) {
      if (newTag.length <= 25) {
        this.errorMaxlength = false
        this.itemOption.push(newTag)
        this.customer_value = newTag
      } else {
        this.errorMaxlength = true
      }
    },
    cancelEdit: function() {
      this.isEdit = false
      this.customer_value = this.cached_customer_value
    },
    saveEdit: function() {
      var vm = this
      var data = {
        pageid: vm.selectedBot.pageid,
        usersid: vm.userid,
        customer_value: vm.customer_value,
        onEdit: function() {
          vm.isEdit = false
          vm.cached_customer_value = vm.customer_value
          vm.$emit('input', vm.customer_value)
        }
      }
      vm.$emit('onEdit', data)
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/analytics/EditCustomerValue.vue